// # Phone codes utility with country data
export const countryCodes = [
  // # Arab Countries (Starting with Egypt)
  { code: '+20', country: 'Egypt', flag: '🇪🇬', name_en: 'Egypt', name_ar: 'مصر' },
  { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦', name_en: 'Saudi Arabia', name_ar: 'السعودية' },
  { code: '+971', country: 'UAE', flag: '🇦🇪', name_en: 'United Arab Emirates', name_ar: 'الإمارات' },
  { code: '+974', country: 'Qatar', flag: '🇶🇦', name_en: 'Qatar', name_ar: 'قطر' },
  { code: '+973', country: 'Bahrain', flag: '🇧🇭', name_en: 'Bahrain', name_ar: 'البحرين' },
  { code: '+965', country: 'Kuwait', flag: '🇰🇼', name_en: 'Kuwait', name_ar: 'الكويت' },
  { code: '+968', country: 'Oman', flag: '🇴🇲', name_en: 'Oman', name_ar: 'عمان' },
  { code: '+962', country: 'Jordan', flag: '🇯🇴', name_en: 'Jordan', name_ar: 'الأردن' },
  { code: '+961', country: 'Lebanon', flag: '🇱🇧', name_en: 'Lebanon', name_ar: 'لبنان' },
  { code: '+963', country: 'Syria', flag: '🇸🇾', name_en: 'Syria', name_ar: 'سوريا' },
  { code: '+964', country: 'Iraq', flag: '🇮🇶', name_en: 'Iraq', name_ar: 'العراق' },
  { code: '+967', country: 'Yemen', flag: '🇾🇪', name_en: 'Yemen', name_ar: 'اليمن' },
  { code: '+970', country: 'Palestine', flag: '🇵🇸', name_en: 'Palestine', name_ar: 'فلسطين' },
  { code: '+216', country: 'Tunisia', flag: '🇹🇳', name_en: 'Tunisia', name_ar: 'تونس' },
  { code: '+213', country: 'Algeria', flag: '🇩🇿', name_en: 'Algeria', name_ar: 'الجزائر' },
  { code: '+212', country: 'Morocco', flag: '🇲🇦', name_en: 'Morocco', name_ar: 'المغرب' },
  { code: '+218', country: 'Libya', flag: '🇱🇾', name_en: 'Libya', name_ar: 'ليبيا' },
  { code: '+249', country: 'Sudan', flag: '🇸🇩', name_en: 'Sudan', name_ar: 'السودان' },

  // # USA & Canada
  { code: '+1', country: 'USA', flag: '🇺🇸', name_en: 'United States', name_ar: 'الولايات المتحدة' },
  { code: '+1', country: 'Canada', flag: '🇨🇦', name_en: 'Canada', name_ar: 'كندا' },

  // # Europe
  { code: '+44', country: 'UK', flag: '🇬🇧', name_en: 'United Kingdom', name_ar: 'المملكة المتحدة' },
  { code: '+49', country: 'Germany', flag: '🇩🇪', name_en: 'Germany', name_ar: 'ألمانيا' },
  { code: '+33', country: 'France', flag: '🇫🇷', name_en: 'France', name_ar: 'فرنسا' },
  { code: '+39', country: 'Italy', flag: '🇮🇹', name_en: 'Italy', name_ar: 'إيطاليا' },
  { code: '+34', country: 'Spain', flag: '🇪🇸', name_en: 'Spain', name_ar: 'إسبانيا' },
  { code: '+351', country: 'Portugal', flag: '🇵🇹', name_en: 'Portugal', name_ar: 'البرتغال' },
  { code: '+31', country: 'Netherlands', flag: '🇳🇱', name_en: 'Netherlands', name_ar: 'هولندا' },
  { code: '+32', country: 'Belgium', flag: '🇧🇪', name_en: 'Belgium', name_ar: 'بلجيكا' },
  { code: '+41', country: 'Switzerland', flag: '🇨🇭', name_en: 'Switzerland', name_ar: 'سويسرا' },
  { code: '+43', country: 'Austria', flag: '🇦🇹', name_en: 'Austria', name_ar: 'النمسا' },
  { code: '+46', country: 'Sweden', flag: '🇸🇪', name_en: 'Sweden', name_ar: 'السويد' },
  { code: '+47', country: 'Norway', flag: '🇳🇴', name_en: 'Norway', name_ar: 'النرويج' },
  { code: '+45', country: 'Denmark', flag: '🇩🇰', name_en: 'Denmark', name_ar: 'الدنمارك' },
  { code: '+358', country: 'Finland', flag: '🇫🇮', name_en: 'Finland', name_ar: 'فنلندا' },
  { code: '+353', country: 'Ireland', flag: '🇮🇪', name_en: 'Ireland', name_ar: 'أيرلندا' },
  { code: '+30', country: 'Greece', flag: '🇬🇷', name_en: 'Greece', name_ar: 'اليونان' },
  { code: '+48', country: 'Poland', flag: '🇵🇱', name_en: 'Poland', name_ar: 'بولندا' },
  
  // # Asia
  { code: '+86', country: 'China', flag: '🇨🇳', name_en: 'China', name_ar: 'الصين' },
  { code: '+91', country: 'India', flag: '🇮🇳', name_en: 'India', name_ar: 'الهند' },
  { code: '+7', country: 'Russia', flag: '🇷🇺', name_en: 'Russia', name_ar: 'روسيا' },
  { code: '+81', country: 'Japan', flag: '🇯🇵', name_en: 'Japan', name_ar: 'اليابان' },
  { code: '+82', country: 'South Korea', flag: '🇰🇷', name_en: 'South Korea', name_ar: 'كوريا الجنوبية' },
  { code: '+852', country: 'Hong Kong', flag: '🇭🇰', name_en: 'Hong Kong', name_ar: 'هونغ كونغ' },
  { code: '+65', country: 'Singapore', flag: '🇸🇬', name_en: 'Singapore', name_ar: 'سنغافورة' },
  { code: '+60', country: 'Malaysia', flag: '🇲🇾', name_en: 'Malaysia', name_ar: 'ماليزيا' },
  { code: '+66', country: 'Thailand', flag: '🇹🇭', name_en: 'Thailand', name_ar: 'تايلاند' },
  { code: '+84', country: 'Vietnam', flag: '🇻🇳', name_en: 'Vietnam', name_ar: 'فيتنام' },
  { code: '+62', country: 'Indonesia', flag: '🇮🇩', name_en: 'Indonesia', name_ar: 'إندونيسيا' },
  { code: '+63', country: 'Philippines', flag: '🇵🇭', name_en: 'Philippines', name_ar: 'الفلبين' },
  { code: '+90', country: 'Turkey', flag: '🇹🇷', name_en: 'Turkey', name_ar: 'تركيا' },
  { code: '+92', country: 'Pakistan', flag: '🇵🇰', name_en: 'Pakistan', name_ar: 'باكستان' },
  { code: '+880', country: 'Bangladesh', flag: '🇧🇩', name_en: 'Bangladesh', name_ar: 'بنغلاديش' },
  
  // # Americas (Latin America)
  { code: '+55', country: 'Brazil', flag: '🇧🇷', name_en: 'Brazil', name_ar: 'البرازيل' },
  { code: '+52', country: 'Mexico', flag: '🇲🇽', name_en: 'Mexico', name_ar: 'المكسيك' },
  { code: '+54', country: 'Argentina', flag: '🇦🇷', name_en: 'Argentina', name_ar: 'الأرجنتين' },
  { code: '+56', country: 'Chile', flag: '🇨🇱', name_en: 'Chile', name_ar: 'تشيلي' },
  { code: '+57', country: 'Colombia', flag: '🇨🇴', name_en: 'Colombia', name_ar: 'كولومبيا' },
  
  // # Africa (Non-Arab)
  { code: '+27', country: 'South Africa', flag: '🇿🇦', name_en: 'South Africa', name_ar: 'جنوب أفريقيا' },
  { code: '+234', country: 'Nigeria', flag: '🇳🇬', name_en: 'Nigeria', name_ar: 'نيجيريا' },
  { code: '+254', country: 'Kenya', flag: '🇰🇪', name_en: 'Kenya', name_ar: 'كينيا' },
  
  // # Oceania
  { code: '+61', country: 'Australia', flag: '🇦🇺', name_en: 'Australia', name_ar: 'أستراليا' },
  { code: '+64', country: 'New Zealand', flag: '🇳🇿', name_en: 'New Zealand', name_ar: 'نيوزيلندا' },

  // # Europe (Additional)
  { code: '+40', country: 'Romania', flag: '🇷🇴', name_en: 'Romania', name_ar: 'رومانيا' },
  { code: '+36', country: 'Hungary', flag: '🇭🇺', name_en: 'Hungary', name_ar: 'المجر' },
  { code: '+420', country: 'Czech Republic', flag: '🇨🇿', name_en: 'Czech Republic', name_ar: 'جمهورية التشيك' },
  { code: '+421', country: 'Slovakia', flag: '🇸🇰', name_en: 'Slovakia', name_ar: 'سلوفاكيا' },
  { code: '+385', country: 'Croatia', flag: '🇭🇷', name_en: 'Croatia', name_ar: 'كرواتيا' },
  { code: '+381', country: 'Serbia', flag: '🇷🇸', name_en: 'Serbia', name_ar: 'صربيا' },
  { code: '+359', country: 'Bulgaria', flag: '🇧🇬', name_en: 'Bulgaria', name_ar: 'بلغاريا' },
  { code: '+380', country: 'Ukraine', flag: '🇺🇦', name_en: 'Ukraine', name_ar: 'أوكرانيا' },
  
  // # Asia (Additional)
  { code: '+855', country: 'Cambodia', flag: '🇰🇭', name_en: 'Cambodia', name_ar: 'كمبوديا' },
  { code: '+856', country: 'Laos', flag: '🇱🇦', name_en: 'Laos', name_ar: 'لاوس' },
  { code: '+95', country: 'Myanmar', flag: '🇲🇲', name_en: 'Myanmar', name_ar: 'ميانمار' },
  { code: '+977', country: 'Nepal', flag: '🇳🇵', name_en: 'Nepal', name_ar: 'نيبال' },
  { code: '+94', country: 'Sri Lanka', flag: '🇱🇰', name_en: 'Sri Lanka', name_ar: 'سريلانكا' },
  { code: '+976', country: 'Mongolia', flag: '🇲🇳', name_en: 'Mongolia', name_ar: 'منغوليا' },
  { code: '+993', country: 'Turkmenistan', flag: '🇹🇲', name_en: 'Turkmenistan', name_ar: 'تركمانستان' },
  { code: '+998', country: 'Uzbekistan', flag: '🇺🇿', name_en: 'Uzbekistan', name_ar: 'أوزبكستان' },
  { code: '+992', country: 'Tajikistan', flag: '🇹🇯', name_en: 'Tajikistan', name_ar: 'طاجيكستان' },
  { code: '+853', country: 'Macau', flag: '🇲🇴', name_en: 'Macau', name_ar: 'ماكاو' },
  { code: '+886', country: 'Taiwan', flag: '🇹🇼', name_en: 'Taiwan', name_ar: 'تايوان' },
  
  // # Americas (Additional Latin America)
  { code: '+51', country: 'Peru', flag: '🇵🇪', name_en: 'Peru', name_ar: 'بيرو' },
  { code: '+58', country: 'Venezuela', flag: '🇻🇪', name_en: 'Venezuela', name_ar: 'فنزويلا' },
  { code: '+593', country: 'Ecuador', flag: '🇪🇨', name_en: 'Ecuador', name_ar: 'الإكوادور' },
  { code: '+591', country: 'Bolivia', flag: '🇧🇴', name_en: 'Bolivia', name_ar: 'بوليفيا' },
  { code: '+595', country: 'Paraguay', flag: '🇵🇾', name_en: 'Paraguay', name_ar: 'باراغواي' },
  { code: '+598', country: 'Uruguay', flag: '🇺🇾', name_en: 'Uruguay', name_ar: 'أوروغواي' },
  { code: '+506', country: 'Costa Rica', flag: '🇨🇷', name_en: 'Costa Rica', name_ar: 'كوستاريكا' },
  { code: '+507', country: 'Panama', flag: '🇵🇦', name_en: 'Panama', name_ar: 'بنما' },
  
  // # Africa (Additional Non-Arab)
  { code: '+251', country: 'Ethiopia', flag: '🇪🇹', name_en: 'Ethiopia', name_ar: 'إثيوبيا' },
  { code: '+233', country: 'Ghana', flag: '🇬🇭', name_en: 'Ghana', name_ar: 'غانا' },
  { code: '+255', country: 'Tanzania', flag: '🇹🇿', name_en: 'Tanzania', name_ar: 'تنزانيا' },
  { code: '+256', country: 'Uganda', flag: '🇺🇬', name_en: 'Uganda', name_ar: 'أوغندا' },
  { code: '+221', country: 'Senegal', flag: '🇸🇳', name_en: 'Senegal', name_ar: 'السنغال' },
  { code: '+237', country: 'Cameroon', flag: '🇨🇲', name_en: 'Cameroon', name_ar: 'الكاميرون' },
  { code: '+225', country: 'Ivory Coast', flag: '🇨🇮', name_en: 'Ivory Coast', name_ar: 'ساحل العاج' },
  
  // # Oceania (Additional)
  { code: '+679', country: 'Fiji', flag: '🇫🇯', name_en: 'Fiji', name_ar: 'فيجي' },
  { code: '+675', country: 'Papua New Guinea', flag: '🇵🇬', name_en: 'Papua New Guinea', name_ar: 'بابوا غينيا الجديدة' },
  { code: '+685', country: 'Samoa', flag: '🇼🇸', name_en: 'Samoa', name_ar: 'ساموا' },
  { code: '+677', country: 'Solomon Islands', flag: '🇸🇧', name_en: 'Solomon Islands', name_ar: 'جزر سليمان' },
  { code: '+678', country: 'Vanuatu', flag: '🇻🇺', name_en: 'Vanuatu', name_ar: 'فانواتو' }
];

// # Helper function to format phone number with country code
export const formatPhoneNumber = (phoneNumber, countryCode) => {
  // # Remove any non-digit characters except +
  const cleaned = phoneNumber.replace(/[^\d+]/g, '');
  
  // # If number already has a country code, return as is
  if (cleaned.startsWith('+')) {
    return cleaned;
  }
  
  // # Add country code if not present
  return `${countryCode}${cleaned}`;
};

// # Helper function to validate phone number
export const validatePhoneNumber = (phoneNumber) => {
  // # Basic regex for international phone numbers
  const phoneRegex = /^\+?[\d\s]{8,20}$/;
  
  // # Remove spaces for counting digits
  const digitsOnly = phoneNumber.replace(/\D/g, '');
  
  return {
    isValid: phoneRegex.test(phoneNumber) && digitsOnly.length >= 8 && digitsOnly.length <= 15,
    message: 'Please enter a valid phone number with country code'
  };
};

// # Helper function to get phone code by nationality or country name
export const getPhoneCodeByNationality = (nationality) => {
  // # Clean and normalize the input
  const searchTerm = nationality.trim().toLowerCase();
  
  // # First try exact match with country name
  const exactMatch = countryCodes.find(
    country => 
      country.country.toLowerCase() === searchTerm ||
      country.name_en.toLowerCase() === searchTerm ||
      country.name_ar === searchTerm
  );
  
  if (exactMatch) {
    return exactMatch.code;
  }
  
  // # If no exact match, try partial match
  const partialMatch = countryCodes.find(
    country => 
      country.country.toLowerCase().includes(searchTerm) ||
      country.name_en.toLowerCase().includes(searchTerm) ||
      country.name_ar.includes(searchTerm)
  );
  
  return partialMatch ? partialMatch.code : null;
};

// # Helper function to get country data by nationality
export const getCountryDataByNationality = (nationality) => {
  // # Clean and normalize the input
  const searchTerm = nationality.trim().toLowerCase();
  
  // # First try exact match
  const exactMatch = countryCodes.find(
    country => 
      country.country.toLowerCase() === searchTerm ||
      country.name_en.toLowerCase() === searchTerm ||
      country.name_ar === searchTerm
  );
  
  if (exactMatch) {
    return exactMatch;
  }
  
  // # If no exact match, try partial match
  const partialMatch = countryCodes.find(
    country => 
      country.country.toLowerCase().includes(searchTerm) ||
      country.name_en.toLowerCase().includes(searchTerm) ||
      country.name_ar.includes(searchTerm)
  );
  
  return partialMatch || null;
};
